// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cOQNQ","icon":"Footer_icon__AaSzF","payoff":"Footer_payoff__Nac+t","allRightsReserved":"Footer_allRightsReserved__uGS3g"};